define('container/argResolvers/WPFieldEvaluatorArgResolver',['underscore', 'bluebird'], function(_, Promise) {

    'use strict';

    function WPFieldEvaluatorArgResolver(fieldEvaluatorServiceId, wpArgResolver, loggerServiceId) {
        this.fieldEvaluatorServiceId = fieldEvaluatorServiceId;
        this.wpArgResolver = wpArgResolver;
        this.loggerServiceId = loggerServiceId;
    }

    WPFieldEvaluatorArgResolver.prototype.canResolveArg = function (argDefinition) {
        return argDefinition.substring(0, 5) === 'fe:wp';
    };

    WPFieldEvaluatorArgResolver.prototype.resolveArg = function (argDefinition, extensionApi) {
        var self = this,
            contentPromise = self.wpArgResolver.resolveArg(argDefinition.substring(3), extensionApi),
            fieldEvaluatorServicePromise = extensionApi.container.get(self.fieldEvaluatorServiceId);

        return Promise.join(contentPromise, fieldEvaluatorServicePromise, function(content, fieldEvaluator) {

            return content.load().then(function () {

                return function (field, params) {
                    if (_.isUndefined(params)) {
                        return content.findFieldByName(field);
                    } else {
                        return fieldEvaluator(content.findFieldByName(field), params);
                    }
                };
            }).catch(function () {
                extensionApi.container.get(self.loggerServiceId).then(function (Logger) {
                    var logger = new Logger('main');

                    logger.error(err);
                });
            });
        });
    };

    return WPFieldEvaluatorArgResolver;
});

